/**
 * WelcomePane
 *
 * Renders in the right column beside the SidebarRail whenever no conversation
 * is active (first login or user navigated away from all conversations on a
 * wide viewport). Fills the available space with brand identity and quick-start
 * actions rather than leaving the area blank.
 */

interface WelcomePaneProps {
  onNewChat: () => void;
}

export function WelcomePane({ onNewChat }: WelcomePaneProps) {
  const suggestions: { icon: string; label: string; description: string }[] = [
    {
      icon: '👤',
      label: 'Add a contact',
      description: 'Save someone important and let Xavior remember the details.',
    },
    {
      icon: '📅',
      label: 'Create an event',
      description: 'Capture an upcoming meeting, trip, or reminder.',
    },
    {
      icon: '📝',
      label: 'Write a note',
      description: 'Jot down an idea, a thought, or anything worth keeping.',
    },
  ];

  return (
    <div className="welcome-pane" role="region" aria-label="Welcome to Xavior">
      <div className="welcome-pane__inner">
        <div className="welcome-pane__brand">
          <img
            src="/favicon.svg"
            alt=""
            aria-hidden="true"
            className="welcome-pane__logo"
          />
          <h1 className="welcome-pane__title">XAVIOR</h1>
        </div>

        <p className="welcome-pane__subtitle">What would you like to do today?</p>

        <ul className="welcome-pane__suggestions" role="list">
          {suggestions.map(({ icon, label, description }) => (
            <li key={label}>
              <button
                type="button"
                className="welcome-pane__suggestion-card"
                onClick={onNewChat}
                aria-label={label}
              >
                <span className="welcome-pane__suggestion-icon" aria-hidden="true">
                  {icon}
                </span>
                <span className="welcome-pane__suggestion-body">
                  <span className="welcome-pane__suggestion-label">{label}</span>
                  <span className="welcome-pane__suggestion-desc">{description}</span>
                </span>
              </button>
            </li>
          ))}
        </ul>

        <button
          type="button"
          className="welcome-pane__new-chat-btn"
          onClick={onNewChat}
        >
          Start a new conversation
        </button>
      </div>
    </div>
  );
}
